import { render, staticRenderFns } from "./ContactQuotaPopup.vue?vue&type=template&id=4546205c&scoped=true&"
import script from "./ContactQuotaPopup.vue?vue&type=script&lang=js&"
export * from "./ContactQuotaPopup.vue?vue&type=script&lang=js&"
import style0 from "./ContactQuotaPopup.vue?vue&type=style&index=0&id=4546205c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546205c",
  null
  
)

export default component.exports